import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=21c1c27a&scoped=true&"
import script from "./inbox.vue?vue&type=script&lang=ts&"
export * from "./inbox.vue?vue&type=script&lang=ts&"
import style0 from "./inbox.vue?vue&type=style&index=0&id=21c1c27a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c1c27a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21c1c27a')) {
      api.createRecord('21c1c27a', component.options)
    } else {
      api.reload('21c1c27a', component.options)
    }
    module.hot.accept("./inbox.vue?vue&type=template&id=21c1c27a&scoped=true&", function () {
      api.rerender('21c1c27a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Account/view/vue/inbox.vue"
export default component.exports